import Edit from "./Edit.js";
export default Edit;
